import { useEffect, useState } from "react";
import { LIST_PAGE_SIZE } from "../config";

export const wait = (seconds = 1) => {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
};

export const useTableDataGenerator = (
  data = [],
  { filters = {}, pageSize = LIST_PAGE_SIZE } = {},
  count = 0,
) => {
  data ??= [];
  data = Array.isArray(data) ? data : [];
  const [currentPage, setCurrentPage] = useState(0);
  console.log(data);
  console.log(filters);
  const skipStart = pageSize * currentPage;
  const skipEnd = pageSize * (currentPage + 1);
  const filterKeys = Object.keys(filters);
  const filterValues = Object.values(filters);
  if (filterKeys.length > 0) {
    data = data.filter((c) => {
      let isValid = true;
      for (const key of filterKeys) {
        if (key.indexOf("last_info__") == 0) {
          const innerKey = key.replace("last_info__", "");
          if (c["last_info"] && c["last_info"][innerKey] && filters[key]) {
            isValid =
              isValid && c["last_info"][innerKey].includes(filters[key]);
          }
        } else if (c[key] && filters[key]) {
          if (key === "month" && filters["month"] !== "") {
            isValid = isValid && c[key] === filters[key];
          } else {
            isValid = isValid && c[key].includes(filters[key]);
          }
        } else if (!c[key]) {
          return (isValid = false);
        }
      }
      return isValid;
    });
  }

  useEffect(() => {
    if (count > 0) {
      setCurrentPage(0);
    }
  }, filterValues);
  const totalCount = count ?? data?.length ?? 0;
  return {
    data: [...data.filter((_, i) => skipStart <= i && i < skipEnd)],
    totalCount,
    totalPageCount: Math.ceil(totalCount / pageSize),
    currentPage,
    goNext() {
      setCurrentPage((current) => current + 1);
    },
    setPage(pageNumber) {
      setCurrentPage(pageNumber);
    },
    goPrevious() {
      setCurrentPage((current) => current - 1);
    },
  };
};
